import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import HelpMenu from 'Workspace/components/WorkspaceHelpMenu';

import WorkspacesPage from './components/WorkspacesPage/';

const Owner = ({ match }) => (
  <>
    <Switch>
      <Route exact path={`${match.path}/workspaces`} component={WorkspacesPage} />
      <Redirect to={`${match.path}/workspaces`} />
    </Switch>
    <HelpMenu />
  </>
);

Owner.propTypes = {
  match: PropTypes.object,
};

export default Owner;
